module.exports = __webpack_public_path__ + "images/3a67a142697a31bd84bc26a3f806c71c.svg";